'use client';

import { useLocalStorageState } from '@/shared/hooks';
import { STORAGE_KEY } from '@/shared/constants';

const ANONYMOUS_USERNAME = 'wishket_random_user';

interface KeywordList {
  [username: string]: string[];
}

interface UseRecentKeywordsProps {
  username?: string;
}

// TODO: useRecentKeywords를 useSearchHistory로 네이밍 변경
const useRecentKeywords = ({
  username = ANONYMOUS_USERNAME,
}: UseRecentKeywordsProps) => {
  const [keywords, setKeywords] = useLocalStorageState<KeywordList>( // 모든 유저 검색정보
    STORAGE_KEY.RECENT_KEYWORD
  );
  const currentUserKeywords = keywords?.[username] ?? [];
  const recentFiveUserKeywords = currentUserKeywords.slice(-5);

  const removeAllCurrentUserKeywords = () => {
    const updatedKeywords = { ...keywords };
    delete updatedKeywords[username];

    setKeywords(updatedKeywords);
  };

  const add = (word: string) => {
    const updatedList = [
      ...currentUserKeywords.filter((item) => item !== word),
      word,
    ];

    setKeywords({
      ...keywords,
      [username]: updatedList,
    });
  };

  const remove = (index: number) => {
    if (currentUserKeywords.length === 1) {
      removeAllCurrentUserKeywords();
      return;
    }

    const targetIndex = currentUserKeywords.length > 5 ? index - 5 : index;
    currentUserKeywords.splice(targetIndex, 1);

    setKeywords({
      ...keywords,
      [username]: currentUserKeywords,
    });
  };

  return {
    list: recentFiveUserKeywords,
    add,
    remove,
    removeAll: removeAllCurrentUserKeywords,
  };
};

export default useRecentKeywords;
